const initState = {
  firstName: '',
  lastName: '',
  message: '',
  showMessage: false,
  redirect: '',
  token: ''
};
const leads = (state = initState, action) => {
  switch (action.type) {
    case 'AUTHENTICATED':
     
      return {
        state: action.payload
      };
    case 'LOG_OUT':
      
      return {
        ...state,
        loading: false,
        redirect: '/',
        token: action.token
      };
    default:
      return state;
  }
};

export default leads;
